var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.6 22.6",
    style: {
      enableBackground: "new 0 0 22.6 22.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B4A64;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Close",
    transform: "translate(11.314) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    className: "st0",
    d: "M13.7,15.6L8,9.9l-5.7,5.7c-0.5,0.5-1.4,0.5-1.9-0.1c-0.5-0.5-0.5-1.3,0-1.8L6.1,8L0.4,2.3 c-0.5-0.5-0.5-1.4,0-1.9s1.4-0.5,1.9,0L8,6.1l5.7-5.7c0.5-0.5,1.4-0.5,1.9,0.1c0.5,0.5,0.5,1.3,0,1.8L9.9,8l5.7,5.7 c0.5,0.5,0.5,1.4-0.1,1.9C15,16.1,14.2,16.1,13.7,15.6L13.7,15.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.da94c5f11f6d64e04756e96594d1a495.svg";
export { ForwardRef as ReactComponent };